// External dependencies
import React from "react";
// import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { Buffer } from 'buffer';

import EncryptionHelper from "./helpers/decrypt";
import CryptoJS from "crypto-js";

import banmedicaTheme from "../src/config/banmedicaTheme";
// import globalState from "./components/Global/state";
import { doLogin, SetVariablesSesion, GetGeneralDays } from "./components/Global/actions";

// Configuration
import store from "./config/store";

// Components
// import Main from "./components/Main/view";
import FiltroBusqueda from "./components/ActualizarArancel/FiltroBusqueda/view";
import FiltroBusquedaSR from "./components/SolicitudesRealizadas/FiltroBusqueda/view";
import FiltroBusquedaRC from "./components/RecargosConvenios/FiltroBusqueda/view";
import FiltroBusquedaRA from "./components/ReajustarArancel/FiltroBusqueda/view";
import FiltroBusquedaSE from "./components/SolicitudesEspeciales/FiltroBusqueda/view";
import FiltroBusquedaPQ from "./components/Paquetes/FiltroBusquedaPQ/view";
import FiltroBusquedaAG from "./components/ArancelGES/FiltroBusquedaArancelGES/view";
import FiltroBusquedaPG from "./components/PaqueteGES/FiltroBusquedaPaqueteGES/view";
import HolaMundo from "./components/Health/view";


import trace from "./helpers/trace";

if (window && !window.Buffer) {
  window.Buffer = Buffer;
}

let UrlDecrypted = null;


function DecryptUrl(url) {
  const algorithm = EncryptionHelper.CIPHERS.AES_256;

  let ivpass = "1234567890abcdef";
  let key = "1234567890abcdefghijklmnopqrstuv";

  // Usamos CryptoJS para parsear los valores
  const iv = CryptoJS.enc.Utf8.parse(ivpass);
  const parsedKey = CryptoJS.enc.Utf8.parse(key);

  UrlDecrypted = EncryptionHelper.decryptText(
    algorithm,
    parsedKey,
    iv,
    url,
    "base64"
  );
}

function parse(cadena) {
  if (cadena !== null) {
    let urlencrypt;
    let modulo = 1;
    if (cadena[0].toString().indexOf("ActualizarArancel") === 0) {
      urlencrypt = cadena[0].substring(18, cadena[0].length);
      modulo = 1;
    }
    if (cadena[0].toString().indexOf("SolicitudesRealizadas") === 0) {
      urlencrypt = cadena[0].substring(22, cadena[0].length);
      modulo = 2;
    }
    if (cadena[0].toString().indexOf("RecargosConvenios") === 0) {
      urlencrypt = cadena[0].substring(18, cadena[0].length);
      modulo = 3;
    }
    if (cadena[0].toString().indexOf("ReajustarArancel") === 0) {
      urlencrypt = cadena[0].substring(17, cadena[0].length);
      modulo = 4;
    }
    if (cadena[0].toString().indexOf("SolicitudesEspeciales") === 0) {
      urlencrypt = cadena[0].substring(22, cadena[0].length);
      modulo = 5;
    }
    if (cadena[0].toString().indexOf("ListadoPaquetes") === 0) {
      urlencrypt = cadena[0].substring(16, cadena[0].length);
      modulo = 6;
    }
    if (cadena[0].toString().indexOf("ArancelGES") === 0) {
      urlencrypt = cadena[0].substring(11, cadena[0].length);
      modulo = 7;
    }
    if (cadena[0].toString().indexOf("PaqueteGES") === 0) {
      urlencrypt = cadena[0].substring(11, cadena[0].length);
      modulo = 8;
    }
    if (cadena[0].toString().indexOf("health") === 0) {
      urlencrypt = cadena[0].substring(7, cadena[0].length);
      modulo = 9;
    }
    const hostname = window && window.location && window.location.hostname;
    if ((hostname.indexOf("localhost") === -1) /*&& (hostname.indexOf("dev-arancel.isaprebanmedica.cl") === -1)*/) {
      if (UrlDecrypted == null) { DecryptUrl(urlencrypt.replace(/-/g, "/")); }
      const arr = UrlDecrypted.split("|");
      /* PARAMETROS ANTIGUOS
      globalState.rutPrestador = arr[0];
      globalState.rutInstitucion = arr[1];
      globalState.isapre = arr[2];
      */
      //console.log("rutPrestador: ", arr[1]);
      //console.log("rutInstitucion: ", arr[2]);
      store.dispatch(SetVariablesSesion({
        rutUsuario: arr[0],
        rutPrestador: arr[1],
        rutInstitucion: arr[2],
        isapre: arr[3],
      }));
    }
    switch (modulo) {
      case 1:
        return (<FiltroBusqueda />);
      case 2:
        return (<FiltroBusquedaSR />);
      case 3:
        return (<FiltroBusquedaRC />);
      case 4:
        return (<FiltroBusquedaRA />);
      case 5:
        return (<FiltroBusquedaSE />);
      case 6:
        return (<FiltroBusquedaPQ />);
      case 7:
        return (<FiltroBusquedaAG />);
      case 8:
        return (<FiltroBusquedaPG />);
      case 9:
        return (<HolaMundo />);
      default:
        return (null);
    }
  } return null;
}

const Intregation = ({ match }) => (
  parse(match.params)
);

// Application root component
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentWillMount() {
    store.dispatch(doLogin("cuenta", () => this.Rerender()));
  }

  Rerender = () => {
    this.setState({ loading: true });
  }

  render() {
    return (
      <div>
        {this.state.loading ?
          <Provider store={store}>
            <MuiThemeProvider muiTheme={banmedicaTheme} >
              <Router>

                <div style={{ width: 990, maxHeight: 1200, overflowY: "auto" }}> {/* Ancho y alto del iframe */}
                  <Route path="/*" component={Intregation} />
                </div>
              </Router>
            </MuiThemeProvider>
          </Provider>
          : <div>cargando...</div>}
      </div>
    );
  }
}

App.defaultProps = {
  // loading: false,
};

App.propTypes = {
  // loading: PropTypes.bool,
};

export default App;
